import script from "./productlist.vue?vue&type=script&setup=true&lang=js"
export * from "./productlist.vue?vue&type=script&setup=true&lang=js"

import "./productlist.vue?vue&type=style&index=0&id=1439ec14&lang=css"

const __exports__ = script;

export default __exports__